import { ReceiptOrderFormInfoDto } from '../generated';
import { ReceiptFormInfo } from '../model/ReceiptFormInfo';

export const parseReceiptFormInfo = (data: ReceiptOrderFormInfoDto): ReceiptFormInfo => {
  return {
    clinics: data.clinicNames
  }
}
